export const CAROUSEL_TITLES: string[] = [ 'revenueManagers', 'complexAlgorithms', 'knowHow', 'functionYieldOn' ];

export interface State {
  cookieAccepted: boolean;
  loginForm: {
    errors: string | null;
  };
  carousel: {
    currentSlideIndex: number;
    titles: string[];
  };
}

export const state: State = {
  cookieAccepted: false,
  loginForm: {
    errors: '',
  },
  carousel: {
    currentSlideIndex: 0,
    titles: CAROUSEL_TITLES,
  },
};
